import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, tap, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from '../error-handler.service';

export type ProjectTariffDescription = {
  title: string;
  desc: string;
  tags: string[];
};

export const ProjectTariffsDescriptionMap: {
  free: ProjectTariffDescription;
  basic: ProjectTariffDescription;
  standart: ProjectTariffDescription;
  professional: ProjectTariffDescription;
  pro: ProjectTariffDescription;
  enterprise: ProjectTariffDescription;
} = {
  free: {
    title: 'Free',
    desc: 'Explore & preview data',
    tags: [
      'Parcel Information Snapshot',
      'Market Price Ranges',
      'Drawing Tools',
      'Map Sharing Board',
    ],
  },
  basic: {
    title: 'Basic',
    desc: 'Individual research & manual analysis',
    tags: [
      'Includes everything in Free',
      'Comprehensive Parcel Data',
      'Exact Market Price Estimates',
      'Layered GIS Mapping',
    ],
  },
  standart: {
    title: 'Standard',
    desc: 'Access detailed property data',
    tags: [
      'Includes everything in Basic',
      'Comprehensive Parcel Data',
      'Exact Market Price Estimates',
      'Layered GIS Mapping',
    ],
  },
  professional: {
    title: 'Plus',
    desc: 'Advanced GIS tools for visualization',
    tags: [
      'Includes everything in Standard',
      'Advanced GIS Parcel visualization',
      'Market Trends Analytics',
      'High-Accuracy Price Estimates',
    ],
  },
  pro: {
    title: 'Pro',
    desc: 'Structured professional workflow',
    tags: [
      'Includes everything in Plus',
      'Advanced visualization of valuation',
      'Market Trends Analytics',
      'High-Accuracy Price Estimates',
    ],
  },
  enterprise: {
    title: 'Enterprise',
    desc: 'Organization-wide control & compliance',
    tags: ['Super AI by Artem', 'ILIA NEED', 'ILIA NEED', 'ILIA NEED'],
  },
};
export type ProjectTariffsData = {
  month: {
    free: number;
    basic?: number;
    standart?: number;
    professional?: number;
    pro?: number;
    enterprise: number;
  };
  year: {
    free: number;
    basic?: number;
    standart?: number;
    professional?: number;
    pro?: number;
    enterprise: number;
  };
};
@Injectable({
  providedIn: 'root',
})
export class ProjectTariffsService {
  private _apiUrl: string = `${environment.apiUrl}/api`;
  private tariffsList: ProjectTariffsData | null = null;
  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService,
  ) {}

  getTariffsList(): Observable<ProjectTariffsData> {
    if (this.tariffsList) {
      return of(this.tariffsList);
    }

    return this.http.get<ProjectTariffsData>(`${this._apiUrl}/project/payment/options`).pipe(
      tap((data) => {
        this.tariffsList = data;
      }),
      catchError((err) => {
        this.errorHandler.handleError(err);
        return throwError(() => err);
      }),
    );
  }
}
